import React from 'react'
import { NumericFormat } from 'react-number-format';

const BadgePills = ({status, amount}) => {

 

  return <>
    {status === "PEN" && <span className="badge rounded-pill pendienteBadge">Pendiente</span>}
    {status === "TER" && <span className="badge rounded-pill terminadoBadge">Terminado</span>}
    {status === "EIR" && <span className="badge rounded-pill eirBadge">EIR</span>}
    {status === "COR" && <span className="badge rounded-pill corteBadge">Corte de demoras</span>}
    {status === "CNA" && <span className="badge rounded-pill navieraBadge">Confirmación de naviera</span>}

    {status === "BAJ" && <span className="badge rounded-pill bajaBadge"> 
                        <NumericFormat 
                        prefix={"$"} suffix={" USD"}  
                        decimalSeparator={"."}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text" 
                        value={amount} 
                        />
                        </span>}
    {status === "MED" && <span className="badge rounded-pill mediaBadge"> 
                        <NumericFormat 
                        prefix={"$"} suffix={" USD"}  
                        decimalSeparator={"."}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text" 
                        value={amount} 
                        />
                        </span>}
    {status === "ALT" && <span className="badge rounded-pill altaBadge">
                        <NumericFormat 
                        prefix={"$"} suffix={" USD"}  
                        decimalSeparator={"."}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text" 
                        value={amount} 
                        />
            </span>}
      {status === "MAL" && <span className="badge rounded-pill muyAltaBadge">
                  <NumericFormat 
                  prefix={"$"} suffix={" USD"}  
                  decimalSeparator={"."}
                  thousandSeparator={true}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  displayType="text" 
                  value={amount} 
                  />
      </span>}
  </>
}

export default BadgePills